import HttpService from "./HttpService";

class DocumentService extends HttpService {
  async submeterDocumento(data) {
    const response = await this.post("/documentos/submeter", data);
    return response.data;
  }

  async getDocumentos(motoristaId) {
    const response = await this.get(`/documentos/motorista/${motoristaId}`);
    return response.data;
  }

  async findMotoristasByEmpresa(empresaId) {
    const response = await this.get(
      `/documentos/empresa/${empresaId}/motoristas`
    );
    return response.data;
  }
}

export default DocumentService;
